import { memo } from 'react';
import { IconProps } from './iconType';

export const ArrowBottomIcon = memo(({ size, color }: IconProps) => {
  return (
    // export된 svg가 있다면 => 코드창에 열어서 있는 코드 아래 형식처럼 수정하기
    // 디자인 파일에서 svg가 있다면 => svg 코드 복사해서 아래 형식처럼 수정하기
    // xmlns 속성은 제거
    <svg width={size} height={size} viewBox="0 0 22 22" fill="none">
      <path
        d="M10.9999 12.0734L15.5372 7.53613L16.8336 8.83249L10.9999 14.6662L5.16632 8.83249L6.46268 7.53613L10.9999 12.0734Z"
        fill={color}
      />
    </svg>
  );
});

ArrowBottomIcon.displayName = 'ArrowBottomIcon';
